import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { useNavigate } from "react-router-dom";
import { FaBookOpen, FaChalkboardTeacher, FaUsers, FaExclamationCircle, FaComments } from "react-icons/fa";

const AdminListData = () => {
  const [adminData, setAdminData] = useState({});
  const [pendingReviews, setPendingReviews] = useState(null);
  const navigate = useNavigate();

  const fetch = async () => {
    try {
      const res = await axiosInstance.get("admin/statistics");
      setAdminData(res?.data?.data || {});
    } catch (error) {
      console.error("Error fetching admin statistics:", error);
    }

    try {
      const reviewsRes = await axiosInstance.get("/testimonials");
      const reviews = reviewsRes.data.data || [];
      const pendingCount = reviews.filter((r) => !r.parentId && (r.status === 0 || r.status === "0")).length;
      setPendingReviews(pendingCount);
    } catch (error) {
      console.error("Error fetching pending reviews count:", error);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const cardStyle = (hoverColor) => ({
    background: "white",
    borderRadius: "20px",
    padding: "24px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
  });

  return (
    <div 
      style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", 
        gap: "20px", 
        marginBottom: "24px",
        fontFamily: "'Outfit', sans-serif"
      }}
    >
      {/* Courses Card */}
      <div
        onClick={() => navigate('/dashboard/course/list', { state: { type: "" } })}
        style={cardStyle("#3b82f6")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(59, 130, 246, 0.08)";
          e.currentTarget.style.borderColor = "#3b82f6";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Courses</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {adminData.hasOwnProperty("courses") ? (
                adminData.courses
              ) : (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              )}
            </h3>
          </div>
          <div style={{
            background: "#eff6ff",
            color: "#3b82f6",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #dbeafe"
          }}>
            <FaBookOpen />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {!adminData.hasOwnProperty("courses") ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#eff6ff",
              color: "#1d4ed8",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{adminData?.thisMonthCourses || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Instructors Card */}
      <div
        onClick={() => navigate('/dashboard/instructor/list')}
        style={cardStyle("#6366f1")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(99, 102, 241, 0.08)";
          e.currentTarget.style.borderColor = "#6366f1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Instructors</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {adminData.hasOwnProperty("instructors") ? (
                adminData.instructors
              ) : (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              )}
            </h3>
          </div>
          <div style={{
            background: "#e0e7ff",
            color: "#6366f1",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #c7d2fe"
          }}>
            <FaChalkboardTeacher />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {!adminData.hasOwnProperty("instructors") ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#e0e7ff",
              color: "#4338ca",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{adminData?.thisMonthInstructors || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Students Card */}
      <div
        onClick={() => navigate('/dashboard/student/Lists')}
        style={cardStyle("#10b981")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(16, 185, 129, 0.08)";
          e.currentTarget.style.borderColor = "#10b981";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Students</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {adminData.hasOwnProperty("students") ? (
                adminData.students
              ) : (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              )}
            </h3>
          </div>
          <div style={{
            background: "#ecfdf5",
            color: "#10b981",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #a7f3d0"
          }}>
            <FaUsers />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {!adminData.hasOwnProperty("students") ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#ecfdf5",
              color: "#047857",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{adminData?.thisMonthStudents || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Courses Under Review Card */}
      <div
        onClick={() => navigate('/dashboard/course/list', { state: { type: "inReview" } })}
        style={cardStyle("#f59e0b")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(245, 158, 11, 0.08)";
          e.currentTarget.style.borderColor = "#f59e0b";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>In Review Courses</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {adminData.hasOwnProperty("moderation") ? (
                adminData.moderation
              ) : (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              )}
            </h3>
          </div>
          <div style={{
            background: "#fffbeb",
            color: "#f59e0b",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #fde68a"
          }}>
            <FaExclamationCircle />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {!adminData.hasOwnProperty("moderation") ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#fffbeb",
              color: "#b45309",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{adminData?.thisMonthStudents || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Pending Reviews Card */}
      <div
        onClick={() => navigate('/dashboard/student/review-approve')}
        style={cardStyle("#e11d48")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(225, 29, 72, 0.08)";
          e.currentTarget.style.borderColor = "#e11d48";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Pending Reviews</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {pendingReviews !== null ? (
                pendingReviews
              ) : (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              )}
            </h3>
          </div>
          <div style={{
            background: "#ffe4e6",
            color: "#e11d48",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #fecdd3"
          }}>
            <FaComments />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {pendingReviews === null ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#ffe4e6",
              color: "#be123c",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              {pendingReviews}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Awaiting moderation</span>
        </div>
      </div>
    </div>
  );
};

export default AdminListData;
